import { UserDto } from '../user/types';

export const LOGIN_SUCCESS = 'AUTH_LOGIN_SUCCESS';

export const LOGOUT_SUCCESS = 'AUTH_LOGOUT_SUCCESS';

export const GET_PROFILE_SUCCESS = 'GET_PROFILE_SUCCESS';

export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS';

export const UPDATE_PASSWORD_SUCCESS = 'UPDATE_PASSWORD_SUCCESS';

export const REQUEST_LOADING = 'AUTH_REQUEST_LOADING';
export const REQUEST_FAILED = 'AUTH_REQUEST_FAILED';

export interface AuthState {
  current: UserDto | null;
  isLoggedIn: boolean;
  isLoading: boolean;
}

export enum Permissions {
  // ============================================
  // DASHBOARD
  // ============================================
  DASHBOARD_VIEW = 'DASHBOARD_VIEW',

  // ============================================
  // USER MANAGEMENT
  // ============================================
  USER_VIEW = 'USER_VIEW',
  USER_CREATE = 'USER_CREATE',
  USER_UPDATE = 'USER_UPDATE',
  USER_UPDATE_PASSWORD = 'USER_UPDATE_PASSWORD',
  USER_UPDATE_STATUS = 'USER_ACTIVE', // Note: maps to USER_ACTIVE

  // ============================================
  // SETTINGS
  // ============================================
  SETTING_VIEW = 'SETTING_VIEW',
  SETTING_CREATE = 'SETTING_CREATE',
  SETTING_UPDATE = 'SETTING_UPDATE',
  SETTING_DELETE = 'SETTING_DELETE',

  // ============================================
  // SALES MODULE
  // ============================================
  QUOTE_VIEW = 'QUOTE_VIEW',
  QUOTE_CREATE = 'QUOTE_CREATE',
  QUOTE_UPDATE = 'QUOTE_UPDATE',
  QUOTE_DELETE = 'QUOTE_DELETE',
  QUOTE_CONVERT = 'QUOTE_CONVERT',
  QUOTE_EXPORT = 'QUOTE_EXPORT',

  OFFER_VIEW = 'OFFER_VIEW',
  OFFER_CREATE = 'OFFER_CREATE',
  OFFER_UPDATE = 'OFFER_UPDATE',
  OFFER_DELETE = 'OFFER_DELETE',

  ORDER_VIEW = 'ORDER_VIEW',
  ORDER_CREATE = 'ORDER_CREATE',
  ORDER_UPDATE = 'ORDER_UPDATE',
  ORDER_DELETE = 'ORDER_DELETE',

  LEAD_VIEW = 'LEAD_VIEW',
  LEAD_CREATE = 'LEAD_CREATE',
  LEAD_UPDATE = 'LEAD_UPDATE',
  LEAD_DELETE = 'LEAD_DELETE',

  CUSTOMER_VIEW = 'CUSTOMER_VIEW',
  CUSTOMER_CREATE = 'CUSTOMER_CREATE',
  CUSTOMER_UPDATE = 'CUSTOMER_UPDATE',
  CUSTOMER_DELETE = 'CUSTOMER_DELETE',

  // ============================================
  // FINANCE MODULE
  // ============================================
  INVOICE_VIEW = 'INVOICE_VIEW',
  INVOICE_CREATE = 'INVOICE_CREATE',
  INVOICE_UPDATE = 'INVOICE_UPDATE',
  INVOICE_DELETE = 'INVOICE_DELETE',
  INVOICE_EXPORT = 'INVOICE_EXPORT',

  PAYMENT_VIEW = 'PAYMENT_VIEW',
  PAYMENT_CREATE = 'PAYMENT_CREATE',
  PAYMENT_UPDATE = 'PAYMENT_UPDATE',
  PAYMENT_DELETE = 'PAYMENT_DELETE',

  EXPENSE_VIEW = 'EXPENSE_VIEW',
  EXPENSE_CREATE = 'EXPENSE_CREATE',
  EXPENSE_UPDATE = 'EXPENSE_UPDATE',
  EXPENSE_DELETE = 'EXPENSE_DELETE',

  TAX_VIEW = 'TAX_VIEW',
  TAX_CREATE = 'TAX_CREATE',
  TAX_UPDATE = 'TAX_UPDATE',
  TAX_DELETE = 'TAX_DELETE',

  PAYMENT_MODE_VIEW = 'PAYMENT_MODE_VIEW',
  PAYMENT_MODE_CREATE = 'PAYMENT_MODE_CREATE',
  PAYMENT_MODE_UPDATE = 'PAYMENT_MODE_UPDATE',
  PAYMENT_MODE_DELETE = 'PAYMENT_MODE_DELETE',

  // ============================================
  // PRODUCTION MODULE
  // ============================================
  PRODUCTION_REQUEST_VIEW = 'PRODUCTION_REQUEST_VIEW',
  PRODUCTION_REQUEST_CREATE = 'PRODUCTION_REQUEST_CREATE',
  PRODUCTION_REQUEST_UPDATE = 'PRODUCTION_REQUEST_UPDATE',
  PRODUCTION_REQUEST_DELETE = 'PRODUCTION_REQUEST_DELETE',
  PRODUCTION_REQUEST_APPROVE = 'PRODUCTION_REQUEST_APPROVE',

  PRODUCTION_LOT_VIEW = 'PRODUCTION_LOT_VIEW',
  PRODUCTION_LOT_CREATE = 'PRODUCTION_LOT_CREATE',
  PRODUCTION_LOT_UPDATE = 'PRODUCTION_LOT_UPDATE',
  PRODUCTION_LOT_DELETE = 'PRODUCTION_LOT_DELETE',
  PRODUCTION_LOT_FINALIZE = 'PRODUCTION_LOT_FINALIZE',

  SFG_VIEW = 'SFG_VIEW',
  SFG_TRANSFER = 'SFG_TRANSFER',
  SFG_CONVERT = 'SFG_CONVERT',

  // ============================================
  // INVENTORY MODULE
  // ============================================
  MATERIAL_VIEW = 'MATERIAL_VIEW',
  MATERIAL_CREATE = 'MATERIAL_CREATE',
  MATERIAL_UPDATE = 'MATERIAL_UPDATE',
  MATERIAL_DELETE = 'MATERIAL_DELETE',

  PRODUCT_VIEW = 'PRODUCT_VIEW',
  PRODUCT_CREATE = 'PRODUCT_CREATE',
  PRODUCT_UPDATE = 'PRODUCT_UPDATE',
  PRODUCT_DELETE = 'PRODUCT_DELETE',

  LOT_VIEW = 'LOT_VIEW',
  LOT_CREATE = 'LOT_CREATE',
  LOT_UPDATE = 'LOT_UPDATE',
  LOT_DELETE = 'LOT_DELETE',
  LOT_MERGE = 'LOT_MERGE',
  LOT_TRANSFER = 'LOT_TRANSFER',

  WAREHOUSE_VIEW = 'WAREHOUSE_VIEW',
  WAREHOUSE_CREATE = 'WAREHOUSE_CREATE',
  WAREHOUSE_UPDATE = 'WAREHOUSE_UPDATE',
  WAREHOUSE_DELETE = 'WAREHOUSE_DELETE',

  RECEIPT_VIEW = 'RECEIPT_VIEW',
  RECEIPT_CREATE = 'RECEIPT_CREATE',
  RECEIPT_UPDATE = 'RECEIPT_UPDATE',
  RECEIPT_DELETE = 'RECEIPT_DELETE',
  RECEIPT_APPROVE = 'RECEIPT_APPROVE',

  ISSUE_VIEW = 'ISSUE_VIEW',
  ISSUE_CREATE = 'ISSUE_CREATE',
  ISSUE_UPDATE = 'ISSUE_UPDATE',
  ISSUE_APPROVE = 'ISSUE_APPROVE',

  // ============================================
  // QUALITY CONTROL MODULE
  // ============================================
  QC_INSPECTION_VIEW = 'QC_INSPECTION_VIEW',
  QC_INSPECTION_CREATE = 'QC_INSPECTION_CREATE',
  QC_INSPECTION_UPDATE = 'QC_INSPECTION_UPDATE',
  QC_INSPECTION_SUBMIT = 'QC_INSPECTION_SUBMIT',

  QC_DASHBOARD_VIEW = 'QC_DASHBOARD_VIEW',
  QC_TREND_VIEW = 'QC_TREND_VIEW',

  DEFECTIVE_LOT_VIEW = 'DEFECTIVE_LOT_VIEW',
  DEFECTIVE_LOT_CREATE = 'DEFECTIVE_LOT_CREATE',
  DEFECTIVE_LOT_UPDATE = 'DEFECTIVE_LOT_UPDATE',
  DEFECTIVE_LOT_DISPOSE = 'DEFECTIVE_LOT_DISPOSE',

  SAMPLE_LOT_VIEW = 'SAMPLE_LOT_VIEW',
  SAMPLE_LOT_CREATE = 'SAMPLE_LOT_CREATE',
  SAMPLE_LOT_UPDATE = 'SAMPLE_LOT_UPDATE',
  SAMPLE_LOT_REINSPECT = 'SAMPLE_LOT_REINSPECT',

  LOT_DISPOSITION_VIEW = 'LOT_DISPOSITION_VIEW',
  LOT_DISPOSITION_CREATE = 'LOT_DISPOSITION_CREATE',

  // ============================================
  // ORGANIZATION MODULE
  // ============================================
  EMPLOYEE_VIEW = 'EMPLOYEE_VIEW',
  EMPLOYEE_CREATE = 'EMPLOYEE_CREATE',
  EMPLOYEE_UPDATE = 'EMPLOYEE_UPDATE',
  EMPLOYEE_DELETE = 'EMPLOYEE_DELETE',

  COMPANY_VIEW = 'COMPANY_VIEW',
  COMPANY_CREATE = 'COMPANY_CREATE',
  COMPANY_UPDATE = 'COMPANY_UPDATE',
  COMPANY_DELETE = 'COMPANY_DELETE',

  PEOPLE_VIEW = 'PEOPLE_VIEW',
  PEOPLE_CREATE = 'PEOPLE_CREATE',
  PEOPLE_UPDATE = 'PEOPLE_UPDATE',
  PEOPLE_DELETE = 'PEOPLE_DELETE',

  // ============================================
  // MATERIAL SUPPLY REQUEST MODULE
  // ============================================
  MATERIAL_SUPPLY_REQUEST_VIEW = 'MATERIAL_SUPPLY_REQUEST_VIEW',
  MATERIAL_SUPPLY_REQUEST_CREATE = 'MATERIAL_SUPPLY_REQUEST_CREATE',
  MATERIAL_SUPPLY_REQUEST_UPDATE = 'MATERIAL_SUPPLY_REQUEST_UPDATE',
  MATERIAL_SUPPLY_REQUEST_DELETE = 'MATERIAL_SUPPLY_REQUEST_DELETE',
  MATERIAL_SUPPLY_REQUEST_ADMIN_APPROVE = 'MATERIAL_SUPPLY_REQUEST_ADMIN_APPROVE',
  MATERIAL_SUPPLY_REQUEST_PROCESS = 'MATERIAL_SUPPLY_REQUEST_PROCESS',
  MATERIAL_SUPPLY_REQUEST_PURCHASE_APPROVE = 'MATERIAL_SUPPLY_REQUEST_PURCHASE_APPROVE',

  // ============================================
  // WORKING HOURS MODULE
  // ============================================
  WORKING_HOURS_VIEW = 'WORKING_HOURS_VIEW',
  WORKING_HOURS_UPDATE = 'WORKING_HOURS_UPDATE',

  // ============================================
  // CUSTOMER SAMPLE SENDING MODULE
  // ============================================
  CUSTOMER_SAMPLE_SENDING_VIEW = 'CUSTOMER_SAMPLE_SENDING_VIEW',
  CUSTOMER_SAMPLE_SENDING_CREATE = 'CUSTOMER_SAMPLE_SENDING_CREATE',
  CUSTOMER_SAMPLE_SENDING_UPDATE = 'CUSTOMER_SAMPLE_SENDING_UPDATE',
  CUSTOMER_SAMPLE_SENDING_DELETE = 'CUSTOMER_SAMPLE_SENDING_DELETE',
  CUSTOMER_SAMPLE_SENDING_ADMIN_APPROVE = 'CUSTOMER_SAMPLE_SENDING_ADMIN_APPROVE',
  CUSTOMER_SAMPLE_SENDING_PREPARE = 'CUSTOMER_SAMPLE_SENDING_PREPARE',
  CUSTOMER_SAMPLE_SENDING_SEND = 'CUSTOMER_SAMPLE_SENDING_SEND',

  // ============================================
  // WAREHOUSE TRANSFER MODULE
  // ============================================
  WAREHOUSE_TRANSFER_VIEW = 'WAREHOUSE_TRANSFER_VIEW',
  WAREHOUSE_TRANSFER_CREATE = 'WAREHOUSE_TRANSFER_CREATE',
  WAREHOUSE_TRANSFER_UPDATE = 'WAREHOUSE_TRANSFER_UPDATE',
  WAREHOUSE_TRANSFER_DELETE = 'WAREHOUSE_TRANSFER_DELETE',
  WAREHOUSE_TRANSFER_APPROVE = 'WAREHOUSE_TRANSFER_APPROVE',
  WAREHOUSE_TRANSFER_DISPATCH = 'WAREHOUSE_TRANSFER_DISPATCH',
  WAREHOUSE_TRANSFER_RECEIVE = 'WAREHOUSE_TRANSFER_RECEIVE',
}
